import isString from 'lodash/isString'

export const safeExternal = href => {
  if (!isString(href) || href.startsWith('http')) {
    return href
  }

  return `http://${href}`
}
